import styled from "styled-components";
import ornament from "../../assets/images/ornament.png"; // <- adaugă asta
import ornament3 from "../../assets/images/ornament3.png"; // <- adaugă asta

const gold = "#c4a453";
const ink = "#1e1b16";

export const Wrap = styled.header`
  width: 100%;
  display: grid;
  place-items: center;
  padding: 36px 16px 18px;
  text-align: center;
  @media (max-width: 960px) {
    padding: 28px 14px 14px;
  }
`;

export const Brand = styled.h1`
  font-size: clamp(22px, 4.5vw, 34px);
  color: ${ink};
  margin: 0;
`;

export const Bar = styled.div`
  width: 120px;
  height: 10px;
  border-bottom: 2px dashed ${gold};
  margin: 12px auto 8px;
`;

export const Crumbs = styled.div`
  opacity: 0.7;
  display: flex;
  gap: 10px;
  font-size: 14px;
  @media (max-width: 960px) {
    font-size: 13px;
  }
`;

export const Ornament = styled.div`
  /* ✅ evităm clamp cu min > max; scale corect pe mobil */
  width: clamp(180px, 50vw, 360px);
  height: clamp(24px, 4.2vw, 42px);
  margin: 10px auto 6px;

  /* ✅ fallback: ornament default peste tot */
  background: center / contain no-repeat url(${ornament});

  /* ✅ pe desktop, dacă există ornament3, îl afișăm */
  @media (min-width: 941px) {
    background-image: url(${ornament3});
  }
  @media (max-width: 480px) {
    margin: 8px auto 4px;
  }
`;
